import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-header__mobile-header" }
const _hoisted_2 = { class: "main-header__up" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "main-header__logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "main-header__widget widget" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "widget__search",
  href: "tel:88002508925"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "main-header__bottom" }
const _hoisted_12 = {
  class: "main-header__list-info",
  "data-sections": ""
}
const _hoisted_13 = ["data-section-title"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "main-header__desctop-header desctop-header" }
const _hoisted_16 = { class: "desctop-header__container" }
const _hoisted_17 = { class: "desctop-header__top" }
const _hoisted_18 = { class: "desctop-header__top-container container" }
const _hoisted_19 = { class: "desctop-header__logo" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "desctop-header__left" }
const _hoisted_22 = { class: "desctop-header__list" }
const _hoisted_23 = { class: "desctop-header__item" }
const _hoisted_24 = { class: "desctop-header__item" }
const _hoisted_25 = { class: "desctop-header__item" }
const _hoisted_26 = { class: "desctop-header__item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("li", { class: "desctop-header__item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://opt.labinskbeef.ru",
    class: "desctop-header__link"
  }, "Для бизнеса")
], -1)
const _hoisted_28 = { class: "desctop-header__right" }
const _hoisted_29 = {
  class: "desctop-header__btn",
  href: "https://agrokomplexshop.ru"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "desctop-header__list-svg" }
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  href: "tel:88002508925",
  class: "desctop-header__item-svg"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = ["src"]
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "desctop-header__bottom" }
const _hoisted_39 = { class: "container" }
const _hoisted_40 = { class: "desctop-header__list-info" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "main-header__menu-popup menu-popup" }
const _hoisted_43 = { class: "menu-popup__one" }
const _hoisted_44 = { class: "menu-popup__header" }
const _hoisted_45 = { class: "menu-popup__logo" }
const _hoisted_46 = ["src"]
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "menu-popup__list" }
const _hoisted_49 = { class: "menu-popup__item" }
const _hoisted_50 = { class: "menu-popup__item" }
const _hoisted_51 = { class: "menu-popup__item" }
const _hoisted_52 = { class: "menu-popup__item" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("li", { class: "menu-popup__item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://opt.labinskbeef.ru",
    class: "menu-popup__link"
  }, "Для бизнеса")
], -1)
const _hoisted_54 = {
  class: "menu-popup__btn",
  href: "https://agrokomplexshop.ru"
}
const _hoisted_55 = ["src"]
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-popup__two\"><div class=\"menu-popup__phone\"><a href=\"tel:88002508925\">8 (800) 250-8-925</a></div><div class=\"menu-popup__mail\"><a href=\"mailto:info@agrokomplexshop.ru\">info@agrokomplexshop.ru</a></div><div class=\"menu-popup__footer\"><a class=\"menu-popup__feedback\" href=\"\">Обратная связь</a><a class=\"menu-popup__privacy\" href=\"\">Политика конфиденциальности</a></div></div>", 1)
const _hoisted_57 = { class: "main-header__menu-popup-tablet menu-popup-tablet" }
const _hoisted_58 = { class: "menu-popup-tablet__one" }
const _hoisted_59 = { class: "menu-popup-tablet__header" }
const _hoisted_60 = { class: "menu-popup-tablet__logo" }
const _hoisted_61 = ["src"]
const _hoisted_62 = ["src"]
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<ul class=\"menu-popup-tablet__list\"><li class=\"menu-popup-tablet__item\"><a class=\"menu-popup-tablet__link\" href=\"\">Каталог</a></li><li class=\"menu-popup-tablet__item\"><a class=\"menu-popup-tablet__link\" href=\"\">Рецепты</a></li><li class=\"menu-popup-tablet__item\"><a class=\"menu-popup-tablet__link\" href=\"\">Доставка</a></li><li class=\"menu-popup-tablet__item\"><a class=\"menu-popup-tablet__link\" href=\"\">О компании</a></li></ul>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Drawer_basket = _resolveComponent("Drawer_basket")!
  const _component_Drawer_pay = _resolveComponent("Drawer_pay")!
  const _component_Dialog_accepted = _resolveComponent("Dialog_accepted")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onOpenMenu())),
          class: "main-header__menu menu"
        }, [
          _createElementVNode("img", {
            src: require('@/assets/img/menu.svg'),
            alt: ""
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/img/header_logo.svg'),
            alt: ""
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "widget__search",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSearch && _ctx.openSearch(...args)))
          }, [
            _createElementVNode("img", {
              src: require('@/assets/img/search.svg'),
              alt: ""
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("a", _hoisted_8, [
            _createElementVNode("img", {
              src: require('@/assets/img/phone.svg'),
              alt: ""
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", {
            class: "widget__profile",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showAuth && _ctx.showAuth(...args)))
          }, [
            _createElementVNode("img", {
              src: require('@/assets/img/profile.svg'),
              alt: ""
            }, null, 8, _hoisted_10)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("ul", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalog.sections, (section, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "main-header__list-info-item",
              key: idx,
              "data-section-title": section.id
            }, [
              _createElementVNode("span", {
                onClick: ($event: any) => (_ctx.gotToSectionById(section.id)),
                class: "main-header__list-info-link"
              }, _toDisplayString(section.name), 9, _hoisted_14)
            ], 8, _hoisted_13))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_v_layout, { class: "desctop-header__leyout" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("img", {
                    src: require('../assets/img/logo_desctop.png'),
                    alt: ""
                  }, null, 8, _hoisted_20)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("ul", _hoisted_22, [
                    _createElementVNode("li", _hoisted_23, [
                      _createElementVNode("span", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToBlock('catalog'))),
                        class: "desctop-header__link"
                      }, "Каталог")
                    ]),
                    _createElementVNode("li", _hoisted_24, [
                      _createElementVNode("span", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToBlock('recipes'))),
                        class: "desctop-header__link"
                      }, "Рецепты")
                    ]),
                    _createElementVNode("li", _hoisted_25, [
                      _createElementVNode("span", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToBlock('delivery'))),
                        class: "desctop-header__link"
                      }, "Доставка")
                    ]),
                    _createElementVNode("li", _hoisted_26, [
                      _createElementVNode("span", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToBlock('about'))),
                        class: "desctop-header__link"
                      }, "О компании")
                    ]),
                    _hoisted_27
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("a", _hoisted_29, [
                    _createElementVNode("img", {
                      src: require('@/assets/img/agro_logo.svg'),
                      alt: ""
                    }, null, 8, _hoisted_30)
                  ]),
                  _createElementVNode("ul", _hoisted_31, [
                    _createElementVNode("li", {
                      class: "desctop-header__item-svg",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openSearch && _ctx.openSearch(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: require('@/assets/img/search.svg'),
                        alt: ""
                      }, null, 8, _hoisted_32)
                    ]),
                    _createElementVNode("a", _hoisted_33, [
                      _createElementVNode("img", {
                        src: require('@/assets/img/phone.svg'),
                        alt: ""
                      }, null, 8, _hoisted_34)
                    ]),
                    _createElementVNode("li", {
                      class: "desctop-header__item-svg",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showAuth && _ctx.showAuth(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: require('@/assets/img/profile.svg'),
                        alt: ""
                      }, null, 8, _hoisted_35)
                    ]),
                    _createElementVNode("li", {
                      class: "desctop-header__item-svg",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showBasket && _ctx.showBasket(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: require('@/assets/img/shopping.svg'),
                        alt: ""
                      }, null, 8, _hoisted_36)
                    ]),
                    _createElementVNode("li", {
                      class: "desctop-header__item-svg desctop-header__item-svg--burger",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onOpenMenuTablet && _ctx.onOpenMenuTablet(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: require('@/assets/img/menu.svg'),
                        alt: ""
                      }, null, 8, _hoisted_37)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_swiper, {
                    slidesPerView: 'auto',
                    class: "mySwiper",
                    "centered-slides": false
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalog.sections, (section, idx) => {
                        return (_openBlock(), _createBlock(_component_swiper_slide, {
                          class: "desctop-header__list-info-item",
                          key: idx
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              onClick: ($event: any) => (_ctx.gotToSectionById(section.id)),
                              class: "desctop-header__list-info-link"
                            }, _toDisplayString(section.name), 9, _hoisted_41)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createVNode(_component_Drawer_basket, {
            ref: "openBasket",
            onOpenPhone: _ctx.openPhone,
            onOpenAccount: _ctx.openAccount,
            onOpenPay: _ctx.openPay
          }, null, 8, ["onOpenPhone", "onOpenAccount", "onOpenPay"]),
          _createVNode(_component_Drawer_pay, {
            ref: "openPay",
            onBackDrawerPay: _ctx.backDrawerPay,
            onOpenAccepted: _ctx.openAccepted
          }, null, 8, ["onBackDrawerPay", "onOpenAccepted"]),
          _createVNode(_component_Dialog_accepted, {
            ref: "openAccepted",
            onOpenHistory: _ctx.openHistory
          }, null, 8, ["onOpenHistory"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("img", {
              src: require('@/assets/img/header_logo.svg'),
              alt: "header__logo"
            }, null, 8, _hoisted_46)
          ]),
          _createElementVNode("div", {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onCloseMenu())),
            class: "menu-popup__close"
          }, [
            _createElementVNode("img", {
              src: require('@/assets/img/close.svg'),
              alt: "close__popup"
            }, null, 8, _hoisted_47)
          ])
        ]),
        _createElementVNode("ul", _hoisted_48, [
          _createElementVNode("li", _hoisted_49, [
            _createElementVNode("span", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToBlock('catalog'))),
              class: "menu-popup__link"
            }, "Каталог")
          ]),
          _createElementVNode("li", _hoisted_50, [
            _createElementVNode("span", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToBlock('recipes'))),
              class: "menu-popup__link"
            }, "Рецепты")
          ]),
          _createElementVNode("li", _hoisted_51, [
            _createElementVNode("span", {
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToBlock('delivery'))),
              class: "menu-popup__link"
            }, "Доставка")
          ]),
          _createElementVNode("li", _hoisted_52, [
            _createElementVNode("span", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goToBlock('about'))),
              class: "menu-popup__link"
            }, "О компании")
          ]),
          _hoisted_53
        ]),
        _createElementVNode("a", _hoisted_54, [
          _createElementVNode("img", {
            src: require('@/assets/img/agro_logo.svg'),
            alt: ""
          }, null, 8, _hoisted_55)
        ])
      ]),
      _hoisted_56
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("img", {
              src: require('@/assets/img/header_logo.svg'),
              alt: "header__logo"
            }, null, 8, _hoisted_61)
          ]),
          _createElementVNode("div", {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onCloseMenuTablet())),
            class: "menu-popup-tablet__close"
          }, [
            _createElementVNode("img", {
              src: require('@/assets/img/close.svg'),
              alt: "close__popup"
            }, null, 8, _hoisted_62)
          ])
        ]),
        _hoisted_63
      ])
    ])
  ], 64))
}